"use client";

import { addFavorite, deleteFavorite } from '@/actions/hotels/favorite';
import { useAuthenticationModalStore } from '@/core/stores/auth';
import { useUserStore } from '@/core/stores/user';
import { useEffect, useState } from 'react';
import { formatFavoredHotels } from './utils/formatFavoritedHotels';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as SolidHeart } from '@fortawesome/pro-solid-svg-icons';
import { faHeart } from '@fortawesome/pro-regular-svg-icons';

const FavouriteButtonHotel = ({ hotelId, dark = false }: { hotelId: string, dark?: boolean }) => {

  const { setFavoriteHotelsDetails, favoriteHotelsDetails, _id } = useUserStore()

  const { setShowAuthModal } = useAuthenticationModalStore()

  const isFavorited = favoriteHotelsDetails && Object.values(formatFavoredHotels(favoriteHotelsDetails)).some((hotels) => hotels.includes(hotelId));

  const [localState, setLocalState] = useState(isFavorited)

  useEffect(() => {
    setLocalState(isFavorited)
  }, [isFavorited])

  async function favorite() {

    setLocalState(true)
    const res = await addFavorite(hotelId)
    const { result, response } = JSON.parse(res)

    if (!response.ok) {
      setLocalState(false)
      return
    }
    setFavoriteHotelsDetails(result.hotels)
  }

  async function removeFavorite() {
    setLocalState(false)
    const res = await deleteFavorite(hotelId)
    const { result, response } = JSON.parse(res)
    if (!response.ok) {
      setLocalState(true)
      return
    }
    setFavoriteHotelsDetails(result.hotels)
  }

  return (
    <button className='size-6 text-sm bg-black/40 rounded-full flex items-center justify-center'
      aria-label="Favourite button"
      onClick={(e) => {
        e.stopPropagation()
        if (!_id) {
          setShowAuthModal(true)
          return
        }
        if (isFavorited) {
          removeFavorite()
        } else {

          favorite()
        }
      }}
    >
      {
        localState ? <FontAwesomeIcon className='text-rose-500 text-base' icon={SolidHeart} />
          :
          <FontAwesomeIcon className='text-white text-base' icon={faHeart} />
      }
    </button>
  );
};

export default FavouriteButtonHotel;
